import {useCallback, useLayoutEffect, useRef} from 'react';

function useEvent<Args extends unknown[], Return>(fn?: (...args: Args) => Return) {
  const fnRef = useRef(fn);

  useLayoutEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  const eventCb = useCallback(
    (...args: Args) => {
      return fnRef.current?.apply(null, args);
    },
    [fnRef],
  );

  return eventCb as NonNullable<typeof fn>;
}

export {useEvent};
